import React, { useEffect, useState } from "react";
import useEmailArtwork from "./EmailArtworkContext";
import EmailListStructure from "../EmailComponents/EmailListTabContents/EmailListStructure";
import useInbox from "../InboxTab/InboxContext";

export default function EArtworkContent() {
  /* ******************** All States ************************* */
  const { selectedProject, setSelectedProject } = useEmailArtwork();

  const [projectMembers, setProjectMembers] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (selectedProject) {
        let members = selectedProject.teamMembers || [];
        setProjectMembers(members);
        // Build google Search Query to retrieve emails including members
        if (members.length === 0) {
          setSearchQuery(null);
          return;
        }
        let query = "";
        members.forEach((member, index) => {
          query += ` from:${member}`;
          if (index !== members.length - 1) {
            query += " OR ";
          }
        });
        setSearchQuery(query);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedProject?.teamMembers]);

  return (
    <div>
      {!selectedProject ?
        <div
          className="flex-grow-1 bg-white flex-center mx-3 my-2 rounded-3 "
          style={{
            height: "97vh",
          }}
        >
          <h4>Please select a project to view emails.</h4>
        </div>
      : <div>
          {projectMembers.length > 0 ?
            <EmailListStructure searchQuery={searchQuery} />
          : <div
              className="flex-grow-1 bg-white flex-center mx-3 my-2 rounded-3 "
              style={{
                height: "97vh",
              }}
            >
              <h4>No members in this project.</h4>
            </div>
          }
        </div>
      }
    </div>
  );
}
